import { useCart } from 'apps/vtex/hooks/useCart.ts'
import { useEffect } from 'preact/hooks'

const LocalStorage = () => {
    const { cart } = useCart()

    useEffect(() => {
        localStorage.setItem('OrderForm', JSON.stringify(cart?.value))
    }, [cart.value])

    return null
}

export default LocalStorage
